<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
// import moment from 'moment';
import DataTable from 'datatables.net-vue3';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import { formatDateToWeb } from "../../../helpers/date-functions";

export default {
    page: {
        title: "Instant Pay list",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Instant Pay List",
            items: [
                {
                text: "Instant Pay List",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
            loadingRoles:true,
            instantpaylisting:[],
            instantpayStatuList:[],
            instantpayDetail:[],
            dtKey:0,

            instantpaystatus:'',
            create_date:'',
            key_search:'',
            refinfo:'',

            testvalue:'',
            clickDetail:'',
        };
    },
    

    methods: {
    getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },
        formatDateToWeb,

        getListInstantPay(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'payments/v1/2c2p/instants')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.instantpaylisting = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        // getListInstantPayStatus(){
        //     axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        //     axios.get(process.env.VUE_APP_AR_API_BASEURL+'curlect/instant/status')
        //     .then(response => {
        //         if (response) {
        //             this.instantpayStatuList = response.data;
        //         } 
        //         else {
        //             this.messageBag = ['No record.'];
        //         }
        //     })
        //     .catch(error => {
        //         this.messageBag = [error.error];
        //     });
        // },

        search(e){
            this.loadingRoles=true,
            e.preventDefault()
            
            const posting_ = {                
                date: this.create_date,
                q: this.key_search,
            };
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'payments/v1/2c2p/instants/search',posting_)
            .then(response => {
                this.instantpaylisting = response.data;
                this.dtKey +=1;
            })
            .catch(error => {
                this.messageBag = [error.error];
            });

            this.loadingRoles=false;
        },

        GetDetailInvoice(id){
            this.clickDetail=true;
            this.testvalue = id;

            this.instantpayDetail = this.instantpaylisting[id];

            console.log(this.instantpayDetail);
        },

        downloadExcel: function () {
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                branch_id: this.branch_id,
                program_id: this.program_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'payments/v1/2c2p/instants/export', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {                    
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Instant Pay Listing.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        resetForm: function ()  { 
            this.create_date = ''; 
            this.key_search = '';
            this.instantpaystatus = '';
            this.loadingRoles=true;

            // this.getListInstantPayStatus();
            this.getListInstantPay();
        },
        ParseFloat(str) { 
            return (Math.round(str * 100) / 100).toFixed(2);   
        },

        copyToClipboard() {
            const text = this.instantpayDetail.url;
            navigator.clipboard.writeText(text)
            
        }

    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
        
    },

    mounted() {
        this.getListInstantPay();
        // this.getListInstantPayStatus();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->
        <div class="card">
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Instant Pay List</h5>
                        </div>
                    </div>                   
                </div>                 
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit="search">
                <div class="row g-3">
                    <div class="col-md-6">
                        <div class="" id="key_search">
                           <input type="text" class="form-control" v-model='key_search' placeholder="Search for Reference Number, Order ID">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="search-box"><i class="ri-search-line search-icon"></i>
                            <flat-pickr v-model="create_date" placeholder="Select Instant Pay Create Date" :config="rangeDateconfig"
                            class="form-control"></flat-pickr>
                        </div>
                    </div>                    
                </div>
                <div class="row g-3 justify-content-end mt-2">
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click="resetForm" class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
                <!--end row-->
                </form>
            </div>

            <div class="card-header border-bottom-dashed">
                 <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <router-link class="btn btn-success w-100" style="background-color: #299CDB;" to="/ar/instantpay/generate" data-key="t-scrollbar">
                                <i class="ri-add-fill align-middle me-1"></i>
                                Generate Instant Pay
                            </router-link>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button @click="downloadExcel()" class="btn btn-success w-100"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                    <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                        <thead class="table-secondary">
                                            <tr>
                                                <th>#.</th>        
                                                <th scope="col">Reference Number</th>           
                                                <th scope="col">Customer Name</th>
                                                <th scope="col">Order ID</th>
                                                <th scope="col">Instant Pay Create Date</th>                    
                                                <th scope="col">Amount ({{ this.getCurrency() }})</th>                    
                                                <th scope="col">Status</th>                    
                                                <th scope="col">Remark</th>                    
                                                <th scope="col">Action</th>                    
                                            </tr>
                                        </thead>

                                        <tbody>                        
                                            <tr v-for="(item, index) in instantpaylisting" :key="index" class="content">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.qpid }}</td>
                                                <td>
                                                    <router-link :to="'/customer/customer-details/'+item.order.customer_id" class="fw-medium link-secondary">
                                                        {{ item.order.customer ? item.order.customer.name_as_per_nric : '' }}
                                                    </router-link></td>
                                                <td>{{ item.order?.orderId }}</td>
                                                <td>{{ formatDateToWeb(item.created_at) }}</td>
                                                <td>{{ ParseFloat(item.amount)  }}</td>
                                                <td>{{ item.status ?? '' }}</td>
                                                <td>{{ '' }}</td>
                                                <td>
                                                    <div class="dropdown">
                                                        <button class="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i class="ri-more-fill align-middle"></i>
                                                        </button>
                                                        <ul class="dropdown-menu dropdown-menu-end">
                                                            <li>
                                                                <span @click="GetDetailInvoice(index)" class="dropdown-item" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" data-target="#myLargeModalLabel">
                                                                    <i class="ri-eye-fill align-bottom me-2 text-muted" ></i> View Instant Pay Details 
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td> 
                                            </tr>
                                        </tbody>
                                    </DataTable>
                                </div>
                                
                                <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="myLargeModalLabel">View Instant Pay Details</h5>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                    aria-label="Close">
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <div v-if="clickDetail && instantpayDetail !== null" >
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-lg-6">
                                                                <p class="text-muted mb-0">
                                                                    Customer Name
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{ instantpayDetail?.order?.customer?.name_as_per_nric }}
                                                                </h6>
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <p class="text-muted mb-0">
                                                                    Created Date
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{ instantpayDetail.created_at }}
                                                                </h6>
                                                            </div>

                                                            <div class="col-lg-6">
                                                                <p class="text-muted mb-0">
                                                                    Email
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{ instantpayDetail?.order?.customer?.email }}
                                                                </h6>
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <p class="text-muted mb-0">
                                                                    Transaction Status
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{instantpayDetail?.status }}
                                                                </h6>
                                                            </div>

                                                            <!-- <div class="col-lg-6">
                                                                <p class="text-muted mb-0">
                                                                    Bank
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{ instantpayDetail['0'].bank }}
                                                                </h6>
                                                            </div> -->
                                                            <div class="col-lg-6">
                                                                <p class="text-muted mb-0">
                                                                    Instant Pay Create Date
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{ instantpayDetail?.created_at }}
                                                                </h6>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <p class="text-muted mb-0">
                                                                    Instant Pay URL
                                                                </p>
                                                                <h6 class="mb-0 me-2" ref="instantPayUrl">
                                                                    {{ instantpayDetail?.url }}
                                                                    <button class="btn btn-sm btn-outline-primary" @click="copyToClipboard">
                                                                        Copy
                                                                    </button>
                                                                </h6>
                                                                
                                                            </div>

                                                            <div class="col-lg-12">
                                                                <p class="text-muted mb-0">
                                                                    Amount ({{ this.getCurrency() }})
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{ parseFloat(instantpayDetail.amount).toFixed(2) }}
                                                                </h6>
                                                            </div>

                                                            <div class="col-lg-12">
                                                                <p class="text-muted mb-0">
                                                                    Remark
                                                                </p>
                                                                <h6 class="mb-0">
                                                                    {{ '' }}
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <br>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="spinner-border text-success" role="status">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>